import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link, useNavigate } from 'react-router-dom';
export function SectionQuestions() {
  const navigate = useNavigate();
  const questions = [{
    id: 101,
    question: 'What is the primary water source for desert flora?',
    answer: 'yes',
    section: 'Section 1',
    course: 'Desert Ecology Basics',
    created: '2023-01-15',
    modified: '2023-06-20'
  }, {
    id: 102,
    question: 'Does the Saguaro cactus grow in the Mojave desert?',
    answer: 'no',
    section: 'Section 2',
    course: 'Desert Ecology Basics',
    created: '2023-01-16',
    modified: '2023-01-16'
  }, {
    id: 103,
    question: 'Is drip irrigation more efficient than sprinklers?',
    answer: 'yes',
    section: 'Section 1',
    course: 'Sustainable Landscaping',
    created: '2023-02-10',
    modified: '2023-08-05'
  }];
  return <div className="space-y-4" data-id="element-1511">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1512">Section Questions</h1>

      {/* Filters */}
      <div className="space-y-2" data-id="element-1513">
        <div data-id="element-1514">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1515">Course</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[200px]" data-id="element-1516">
            <option value="" data-id="element-1517">All Courses</option>
            <option value="1" data-id="element-1518">Desert Ecology Basics</option>
            <option value="2" data-id="element-1519">Advanced Water Conservation</option>
          </select>
        </div>
        <div data-id="element-1520">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1521">Section</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[140px]" data-id="element-1522">
            <option value="" data-id="element-1523">All Sections</option>
            <option value="1" data-id="element-1524">Section 1</option>
            <option value="2" data-id="element-1525">Section 2</option>
          </select>
        </div>
        <div className="flex items-center gap-4" data-id="element-1526">
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1527">
            Search
          </Button>
          <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions/add')} data-id="element-1528">
            <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1529" />
            Add
          </Button>
        </div>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1530">
        <div className="overflow-x-auto" data-id="element-1531">
          <table className="w-full text-sm text-left" data-id="element-1532">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1533">
              <tr data-id="element-1534">
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1535">
                  Id
                </th>
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-1536">
                  Question
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1537">
                  Answer
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-24" data-id="element-1538">
                  Section
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1539">Course</th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1540">
                  Created
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1541">
                  Modified
                </th>
                <th className="px-4 py-3 text-center w-32" data-id="element-1542">
                  <div data-id="element-1543">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1544">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1545">
              {questions.map(q => <tr key={q.id} className="hover:bg-slate-50" data-id="element-1546">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1547">
                    {q.id}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-1548">
                    {q.question}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center capitalize" data-id="element-1549">
                    {q.answer}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1550">
                    <Link to="#" className="text-blue-600 hover:underline" data-id="element-1551">
                      {q.section}
                    </Link>
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1552">
                    <Link to="#" className="text-blue-600 hover:underline" data-id="element-1553">
                      {q.course}
                    </Link>
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1554">
                    {q.created}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1555">
                    {q.modified}
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-1556">
                    <div className="flex items-center justify-center gap-2" data-id="element-1557">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/questions/view/${q.id}`)} data-id="element-1558">
                        <Eye className="h-4 w-4" data-id="element-1559" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/questions/edit/${q.id}`)} data-id="element-1560">
                        <Edit className="h-4 w-4" data-id="element-1561" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1562">
                        <Trash2 className="h-4 w-4" data-id="element-1563" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1564">
        <button className="hover:underline" data-id="element-1565">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1566">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1567">1</span>
        <span className="text-slate-400" data-id="element-1568">|</span>
        <button className="hover:underline" data-id="element-1569">2</button>
        <span className="text-slate-400" data-id="element-1570">|</span>
        <button className="hover:underline" data-id="element-1571">3</button>
        <span className="text-slate-400" data-id="element-1572">|</span>
        <button className="hover:underline" data-id="element-1573">next &gt;&gt;</button>
      </div>
    </div>;
}